export class Tools {
    public static serializeToQueryString(data: any): string {
        if (data === null || data === undefined) {
            return null;
        }
        const str: any = [];
        for (const p in data) {
            if (data[p] !== null && data[p] !== undefined) {
                str.push(encodeURIComponent(p) + '=' + encodeURIComponent(data[p]));
            }
        }
        return str.join('&');
    }

    public static extendObject(obj1: any, obj2: any): any {
        if (obj1 === null || obj2 === null) {
            return null;
        }
        if (obj1 === null) {
            return obj2;
        }
        if (obj2 === null) {
            return obj1;
        }
        const str: any = obj1;
        // tslint:disable-next-line:forin
        for (const i in obj2) {
            str[i] = obj2[i];
        }
        return str;
    }

    public static Deserialize(data: string): any {
        return JSON.parse(data, Tools.ReviveDateTime);
    }

    private static ReviveDateTime(key: any, value: any): any {
        if (typeof value === 'string') {
            const a: RegExpExecArray = /\/Date\((\d*)\)\//.exec(value);
            if (a) {
                return new Date(+a[1]);
            }
        }
        return value;
    }

     public static ContainsInArray(items: any[], field: string, value: any): boolean {
        if (items === null || items.length === 0 || field === null || value === null) {
            return false;
        }
        for (const p in items) {
            if (items[p][field] !== null && items[p][field] === value) {
                return true;
            }
        }
        return false;
    }

    public static CountInArray(items: any[], field: string, value: any): number {
        if (items === null || items.length === 0 || field === null || value === null) {
            return 0;
        }
        let hints = 0;
        for (const p in items) {
            if (items[p][field] !== null && items[p][field] === value) {
                hints++;
            }
        }
        return hints;
    }

    public static ConvertToSelectize(items: any[], id: string = 'Identifier', text: string = 'Name'): any[] {
        const result = [];
        if (items === null || items.length === 0) {
            return result;
        }
        if (text === null) {
            items.forEach((e) => result.push(e[id]));
        } else {
            items.forEach((e) => result.push({value : e[id], text: e[text]}));
        }
        return result;
    }
}



// WEBPACK FOOTER //
// C:/WORK/ZENN/mcr-contabilidade-fileshare/Application/ApplicationUI/src/app/shared/utilities/tools.ts